import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const navLinks = [
  { name: "Lavori", href: "#lavori" },
  { name: "Servizi", href: "#servizi" },
  { name: "Prezzi", href: "#prezzi" },
];

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 20;
      if (isScrolled !== scrolled) {
        setIsScrolled(scrolled);
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isScrolled]);

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      data-testid="header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "glass-header py-3" : "bg-white/0 py-4"
      }`}
    >
      <div className="container-custom">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a
            href="#"
            data-testid="logo"
            className="flex items-center"
            aria-label="ALRender Home"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            <span className="text-xl font-bold text-slate-900 font-['Sora'] tracking-tight">
              AL<span className="text-blue-600">Render</span>
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.name}
                data-testid={`nav-${link.name.toLowerCase()}`}
                onClick={() => scrollToSection(link.href)}
                className="text-slate-700 hover:text-slate-900 font-medium transition-colors text-sm"
              >
                {link.name}
              </button>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <button
              data-testid="header-cta"
              data-umami-event="richiedi-preventivo"
              data-umami-event-sezione="header"
              onClick={() => scrollToSection("#contatto")}
              className="btn-primary text-sm"
            >
              Contattaci
            </button>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2 text-slate-700"
            aria-label="Toggle mobile menu"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div
            data-testid="mobile-menu"
            className="md:hidden mt-4 pb-4 border-t border-slate-100 pt-4"
          >
            <nav className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <button
                  key={link.name}
                  onClick={() => scrollToSection(link.href)}
                  className="text-slate-600 hover:text-slate-900 font-medium text-left py-2"
                >
                  {link.name}
                </button>
              ))}
              <button
                data-umami-event="richiedi-preventivo"
                data-umami-event-sezione="header-mobile"
                onClick={() => scrollToSection("#contatto")}
                className="btn-primary text-sm mt-2 w-full"
              >
                Contattaci
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
